module.exports = __webpack_public_path__ + "img/Boss-2.e534330b.png";